<template>
  <ul class="step-indicator">
    <li v-for="n in steps" :key="n" class="step-item">
      <button
        :title="`Go to step ${n}`"
        @click="$emit('stepClick', n)"
        class="step-btn"
        :class="{ active: currentStep === n }"
        :style="{
          borderColor: color,
          backgroundColor: currentStep === n ? color : 'transparent',
        }"
      />
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    steps: {
      type: Number,
      default: 1,
    },
    currentStep: {
      type: Number,
      defualt: 1,
    },
    color: {
      type: String,
      default: '#fff',
    },
  },
};
</script>

<style scoped>
.step-indicator {
  display: flex;
  list-style: none;
  justify-content: center;
  margin: 0;
  padding: 0;
}

.step-item {
  margin: 0 3px;
}

.step-btn {
  border-radius: 100px;
  border-style: solid;
  border-width: 1px;
  height: 8px;
  width: 8px;
}
</style>
